
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateProjectLinkNumberDtoFormGroup() {
return new FormGroup({
    localProjectId: new FormControl<number | undefined>(undefined, [Validators.required]),
    externalTenantId: new FormControl<number | undefined>(undefined, [Validators.required]),
    externalProjectNumber: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
})
;
}
      